// extracted by mini-css-extract-plugin
export default {"fullWidth":"un-z","image":"vn-z","lazyLoadPicture":"wn-z","lazyLoadSpinner":"xn-z","lazyLoadSpin":"yn-z","lazyLoadImage":"zn-z","hasStyledAspectRatio":"An-z"};